<template>
	<div class="home_index">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span>注意事项</span>
			</div>
			<div v-for="(t,i) in tips" :key="t" class="text_item">
				{{(i+1)+'、'+ t}}
			</div>
			<div class="text item">
				<font color="red">！！！重要的事情说三遍</font>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tips: ['请谨慎修改数据1', '请谨慎修改数据2', '请谨慎修改数据3', ]
			}
		}
	}
</script>
<style lang="scss" scoped>
	.home_index {
		.text_item {
			font-size: 14px;
			margin-bottom: 18px;
			line-height: 30px;
		}
	}
</style>
